<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :model="formInline" class="searchBar">
      <el-row>
        <el-col :span="8">
          <el-form-item label="角色名称">
            <el-input
              size="small"
              v-model="formInline.roleName"
              placeholder="输入角色名称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >搜索</el-button
            >
            <el-button
              size="small"
              type="info"
              icon="el-icon-delete"
              @click="handleReset"
              >清空</el-button
            >
            <el-button
              size="small"
              v-hasPerm="btn_perm_type.role.add"
              @click="handleEdit()"
              icon="el-icon-plus"
              >新增</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="userData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column sortable prop="id" label="编号"> </el-table-column>
      <el-table-column sortable prop="roleName" label="名称"> </el-table-column>
      <el-table-column
        sortable
        prop="createTime"
        label="创建时间"
        :formatter="handleFormatDate"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="updateTime"
        label="更新时间"
        :formatter="handleFormatDate"
      >
      </el-table-column>
      <el-table-column align="center" label="操作" width="240">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.role.update"
            type="primary"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.role.delete"
            type="danger"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.role.update"
            type="success"
            @click="handleAuth(scope.row)"
            >授权</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination :pager="pager" @pager="handlePager"></Pagination>
    <!-- 编辑界面 -->
    <EditForm
      :visible.sync="editFormVisible"
      :editForm="editForm"
      :title="title"
      @confirm="handleConfirmForEditForm"
    ></EditForm>
    <Menu
      :menus="editMenus"
      :visible.sync="menuVisible"
      @confirm="handleConfirmForSelectMenu"
    ></Menu>
  </div>
</template>

<script>
import { listRole, delRole, authRole } from "@/api/system/role";
import Pagination from "@/components/pagination";
import EditForm from "./add-edit";
import Menu from "./add-edit/menu.vue";
import { timestampToDate } from "@/utils";
import { BTN_PERMS_TYPE } from "@/utils/permissions";

export default {
  data() {
    return {
      btn_perm_type: BTN_PERMS_TYPE,
      loading: false,
      menuVisible: false,
      editFormVisible: false,
      selectRow: null,
      title: "添加角色",
      editForm: {
        id: "",
        roleName: "",
        createTime: "",
        updateTime: "",
      },
      editMenus: [],
      formInline: {
        roleName: "",
      },
      userData: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 1,
      },
    };
  },
  components: {
    Pagination,
    EditForm,
    Menu,
  },
  created() {
    this.getData();
  },
  methods: {
    handleFormatDate(row, column, cellValue) {
      if (cellValue) {
        return timestampToDate(cellValue);
      }

      return cellValue;
    },
    getData() {
      this.loading = true;
      listRole(this.pager.currentPage, this.pager.pageSize, this.formInline)
        .then(({ content, page, size, totalCount }) => {
          this.userData = content;
          this.pager.currentPage = page;
          this.pager.pageSize = size;
          this.pager.total = totalCount;
          this.selectRow = null;
        })
        .catch(this.$message.error)
        .finally(() => {
          this.loading = false;
        });
    },
    handlePager(pager) {
      this.pager.currentPage = pager.currentPage;
      this.pager.pageSize = pager.pageSize;
      this.getData();
    },
    handleSearch() {
      this.getData();
    },
    handleReset() {
      this.formInline = {
        roleName: "",
      };
      this.getData();
    },
    handleEdit(row) {
      if (row) {
        this.title = "修改角色";
        this.editForm = row;
      } else {
        this.title = "添加角色";
        this.editForm = {};
      }
      this.editFormVisible = true;
    },
    handleDelete(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delRole(row.id)
            .then(() => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.getData();
            })
            .catch(() => {
              this.$message.error("数据删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除！",
          });
        });
    },
    handleAuth(row) {
      this.selectRow = row;
      this.menuVisible = true;
      this.editMenus = row.menus || [];
    },
    handleConfirmForEditForm() {
      this.getData();
    },
    handleConfirmForSelectMenu(rows) {
      authRole(this.selectRow.id, {
        id: rows.map((item) => item.id).join(","),
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getData();
        })
        .catch(() => {
          this.$message.error("数据授权失败，请稍后再试！");
        });
    },
  },
};
</script>

<style scoped>
.searchBar {
  margin-top: 20px;
  height: 50px;
}
.el-input {
  width: auto !important;
}
</style>

 


// WEBPACK FOOTER //
// src/views/system/role/index.vue